import React from 'react';
import { Box, Text } from '@wix/design-system';
export const StepCircleHeading = _ref => {
  let step = _ref.step,
    children = _ref.children,
    dataHook = _ref.dataHook;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "SP2",
    dataHook: dataHook,
    style: {
      alignItems: 'baseline'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    border: "1px solid var(--wds-color-border-dark-primary-active)",
    align: "center",
    verticalAlign: "middle",
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, step)), children);
};
//# sourceMappingURL=StepCircleHeading.js.map